import { render, staticRenderFns } from "./UserPolicies.vue?vue&type=template&id=ffeb029e"
import script from "./UserPolicies.vue?vue&type=script&lang=js"
export * from "./UserPolicies.vue?vue&type=script&lang=js"
import style0 from "./UserPolicies.vue?vue&type=style&index=0&id=ffeb029e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports